import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    bannerContainer: {
        width: '100%',
        zIndex: 1,
        position: 'relative',
        minHeight: 0,
        '& img': {
            width: '100%',
            objectFit: 'cover',
            maxHeight: 355,
            minHeight: 200
        }
    },
    hideOnMobile: {
        [theme.breakpoints.up('sm')]: {
            display: 'none'
        }
    },
    unavailable: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 100
    },
    tabBox: {
        marginBottom: 30
    },
    shareButton: {
        position: 'absolute',
        top: 20,
        right: 20,
        cursor: 'pointer',
        backgroundColor: 'white',
        borderRadius: 4
    },
    addBannerCTA: {
        color: 'white',
        fontSize: 22,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    pageContent: {
        width: '100%',
        minHeight: 800
    },
    schoolInfo: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: 32,
        [theme.breakpoints.down('sm')]: {
            gap: 20,
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: 20
        }
    },
    logo: {
        width: '80%',
        height: '100%',
        objectFit: 'contain'
    },
    logoBox: {
        display: 'flex',
        justifyContent: 'flex-end',
        position: 'relative',
        zIndex: 1,
        marginTop: -46,
        paddingRight: 16,
        width: '25%',
        [theme.breakpoints.down('sm')]: {
            width: 'unset',
            marginTop: -93
        }
    },
    logoCircle: {
        width: 186,
        height: 186,
        display: 'flex',
        justifyContent: 'center',
        overflow: 'hidden',
        position: 'relative',
        background: 'var(--background-white)',
        boxShadow: 'var(--box-shadow)',
        border: 'var(--border)',
        borderRadius: '50%'
    },
    schoolInfoText: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        paddingLeft: 16,
        width: '75%',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            alignItems: 'center'
        }
    },
    iconsContainer: {
        display: 'flex',
        gap: 8
    },
    iconButton: {
        backgroundColor: theme.palette.bg.silver,
        width: 30,
        height: 30,
        padding: 6,
        '&:hover': {
            backgroundColor: theme.palette.bg.purple
        }
    },
    passportSchoolDescription: {
        marginTop: 30
    },
    ctaBox: {
        width: '100%',
        backgroundColor: theme.palette.bg.yellow,
        borderRadius: 20,
        padding: '20px 30px',
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
        textAlign: 'center',
        marginTop: 36
    },
    facultyCtaBox: {
        backgroundColor: theme.palette.bg.yellow,
        borderRadius: 20,
        padding: '40px 30px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: 24,
        textAlign: 'center',
        minHeight: 430,
        height: '100%'
    },
    blurbDescription: {
        fontSize: 24
    },
    ctaFacultyTitle: {
        fontSize: 30
    },
    ctaFacultyDescription: {
        fontSize: 18
    },
    schoolNameAndCTA: {
        display: 'flex',
        gap: 12,
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column-reverse'
        }
    },
    editPageButton: {
        minWidth: 'fit-content'
    },
    schoolName: {
        fontFamily: 'GreedWide-Bold',
        fontSize: 28,
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    schoolDetailsFlex: {
        display: 'flex',
        gap: 20,
        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap',
            justifyContent: 'center',
            textAlign: 'center'
        }
    },
    schoolDetails: {
        display: 'flex',
        gap: 8,
        alignItems: 'center'
    },
    schoolBodyContainer: {
        marginBottom: 40
    },
    schoolTitle: {
        marginBottom: 20,
        color: 'var(--foreground-black)',
        fontSize: 24,
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        }
    },
    schoolDescription: {
        color: 'var(--foreground-black)',
        fontSize: 18,
        lineHeight: 22,
        '& a': {
            color: 'var(--background-black)',
            textDecoration: 'underline',
            '&:hover': {
                color: 'var(--background-purple)'
            }
        }
    },
    moreInfoButton: {
        width: '100%'
    },
    schoolBodyRightSide: {
        display: 'flex',
        flexDirection: 'column',
        width: '75%',
        [theme.breakpoints.down('md')]: {
            width: '66%'
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        }
    },
    schoolBodyLeftSide: {
        width: '25%',
        height: 'fit-content',
        overflowWrap: 'break-word',
        [theme.breakpoints.down('md')]: {
            width: '25%'
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            border: '1px solid var(--foreground-silver)',
            borderRadius: 'var(--border-radius)',
            padding: 12,
            margin: '20px 0'
        }
    },
    statsContainer: {
        marginTop: 36
    },
    articleContainer: {
        marginTop: 36
    },
    articleTitle: {
        fontSize: 20
    },
    articleBox: {
        marginTop: 16
    },
    videoBox: {
        '& iframe': {
            border: 'var(--border)',
            borderRadius: 20,
            boxShadow: 'var(--box-shadow)'
        }
    },
    schoolBodyOverviewImages: {
        width: '100%',
        marginTop: 40
    },
    svgCircle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.bg.silver,
        borderRadius: 30,
        width: 42,
        height: 42,
        [theme.breakpoints.down('sm')]: {
            width: 36,
            height: 36
        }
    },
    svgIcon: {
        width: 22,
        [theme.breakpoints.down('sm')]: {
            width: 18
        }
    },
    faqPaper: {
        padding: 36,
        [theme.breakpoints.down('sm')]: {
            padding: 16
        }
    },
    faqTitleBox: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    },
    faqTitle: {
        fontSize: 24,
        [theme.breakpoints.down('sm')]: {
            fontSize: 20
        }
    },
    faqQuestions: {
        marginLeft: 50,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0
        }
    },
    faqBox: {
        '&:last-of-type $faqAnswer': {
            borderBottom: 'none',
            paddingBottom: 0
        }
    },
    faqQuestion: {
        marginTop: 30,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
        [theme.breakpoints.down('sm')]: {
            '& h2': {
                fontSize: 18
            },
            marginTop: 20
        }
    },
    faqAnswer: {
        fontSize: 20,
        paddingBottom: 30,
        paddingTop: 15,
        borderBottom: '1px solid var(--background-silver)',
        [theme.breakpoints.down('sm')]: {
            fontSize: 16,
            paddingBottom: 20,
            paddingTop: 10
        }
    },
    faqArrow: {
        width: 24,
        height: 24,
        '&:hover': {
            color: theme.palette.bg.purple
        }
    },
    moreInfoButtonMain: {
        width: 'unset'
    },
    moreInfoButtonBox: {
        marginTop: 50,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 24
    },
    facultyCardPaper: {
        minHeight: 430,
        height: '100%',
        minWidth: 'unset'
    },
    facultyCardImage: {
        borderRadius: '20px 20px 0 0',
        display: 'block',
        width: '100%',
        height: '141px',
        objectFit: 'cover',
        [theme.breakpoints.up('md')]: {
            height: '173px'
        }
    },
    facultyCardBody: {
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: 'calc(100% - 173px)'
    },
    facultyCardmoreInfoUrl: {
        display: 'flex',
        alignItems: 'center',
        gap: 12
    },
    facultyCardTitle: {
        minHeight: 45,
        marginBottom: 10
    },
    campusImage: {
        width: '100%'
    },
    campusImageBox: {
        marginBottom: 30,
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        }
    }
}))
